import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Store } from '@ngxs/store';
import 'rxjs/add/observable/of';
import { FunctionalityService } from '../internal/shared/functionality.service';
import { UserService } from '../internal/shared/user.service';
import { AuthService } from './auth.service';
import { AuthState } from './auth.state';
import { TitleService } from './title.service';

@Injectable()
export class AuthGuard implements CanActivate {
  private queryParamsSub: any;

  constructor(
    private store: Store,
    private authService: AuthService,
    private router: Router,
    private titleService: TitleService,
    private functionalityService: FunctionalityService,
    private userService: UserService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = this.store.selectSnapshot(AuthState.token);

    // if (route.queryParams['email_verification_token'])
    //   this.store.dispatch(
    //     new Navigate([
    //       '/external?email_verification_token=' +
    //         route.queryParams['email_verification_token']
    //     ])
    //   );
    if (!token) {
      // FIXME: should be this.store.dispatch(new Logout()); but is buggy in NGXS-Router-Plugin in version 3.5.1
      this.router.navigate(['/external/logout']);
      return false;
    } else return true;

    // return Observable.create(observer => {
    //   this.userService.currentUser.subscribe((user: any) => {
    //     this.titleService.setShowLocation(false);
    //     if (this.functionalityService.functionality == null) {
    //       this.functionalityService.needsToChooseAccountType = user.needsToChooseAccountType;
    //       this.functionalityService.functionality = user.functionality as Functionality;
    //     }
    //     observer.next(true);
    //   });
    // });
  }
}
